export const RPMCalendar = (function () {
	'use strict';

	let weeklyCalendar, calendar;
	
	function init() {
		weeklyCalendar = document.querySelector('#weekly-calendar');
		calendar = document.querySelector('#cal');

		if(weeklyCalendar) {
			weekly(); 
		}
		if(calendar) {
			monthly(); 
		}
	}

	function weekly() {
		weeklyCalendar = document.querySelector('#weekly-calendar');
		if(!weeklyCalendar) return;
		// console.log(weeklyCalendar);

		var COMMONUTILS = {
			pageWidth: function() {
				"use strict";
				// console.log('sdsdfdsf');
				return document.documentElement.clientWidth;
			},

			// FUNCTION TO EXECUTE CODE BASED ON LOCATION
			userLocation: function() {
				"use strict";

				// let json = 

				// console.log( weeklyCalendar.dataset.events );

				SCHEDULE.initWeekly();
				SCHEDULE.Fetch( weeklyCalendar.dataset.events,
					function() {
						SCHEDULE.Weekly("#weekly-calendar");
					}
				);

			}

		};

		// NAMESPACE FOR SCHEDULE FUNCTIONS
		var SCHEDULE = {
			// JSON results for show dates and times will be stored here
			Times: null,
			Avail: null,

			// sched: 'calendar/_data/schedule.json?4',
			Schedule: null,


			getData: function(schedule, targetdiv, href) {

				// console.log("schedule: ", schedule);

				$.getJSON(schedule, {
					format: "json"
				}, function(data) {

					// data = JSON.stringify(data);


					var dd = new Date();
					var dn = dd.getMonth();
					dn++; // because months are 0 indexed

					for (di = 0; di <= data.schedule_info.length; di++) { // changed < to <= to compare fill length

						currentMonth = Number(data.schedule_info[0].dateID);

						if (currentMonth < dn) {
							data.schedule_info.shift();
						}

					}


					//data.schedule_info.shift();
					// console.log(data.schedule_info[1].dateID);



					// SCHEDULE.Schedule = data;
					// console.log(SCHEDULE.Schedule)
					// var results = SCHEDULE.schedulePop(SCHEDULE.Schedule, href); //********
					// $(targetdiv).append(results);


					// HIDE ARROWS ON FIRST/LAST MONTHS
					$(".cal-right").click(function(e) {
						e.preventDefault();
						var months = $(".month").length - 1;
						var next = $(".month:visible").index();

						if ($(".cal-left").hasClass("inactive")) {
							$(".cal-left").removeClass("inactive");
						};
						if ($(".month:visible").index() < months) {
							$(".month:visible").hide();
							$(".month").eq(next).fadeIn("slow");
						} else if ($(".month:visible").index() == months) {
							$(this).addClass("inactive");
							$(".month:visible").hide();
							$(".month").eq(next).fadeIn("slow");
						}
					});

					$(".cal-left").click(function(e) {
						e.preventDefault();
						var months = 1;
						var next = $(".month:visible").index() - 2;
						if ($(".cal-right").hasClass("inactive")) {
							$(".cal-right").removeClass("inactive");
						};
						if ($(".month:visible").index() > months) {
							$(".month:visible").hide();
							$(".month").eq(next).fadeIn("slow");
						} else if ($(".month:visible").index() == months) {
							$(this).addClass("inactive");
							$(".month:visible").hide();
							$(".month").eq(next).fadeIn("slow");
						}
					});

					//COMMONUTILS.mobileTickets (".ticket-link.premium-tickets, .month a", "10232");
				});
			},

			// Get JSON file, call appropriate parsing function after
			Fetch: function(source, callback) {
				if(typeof source === 'string') {
					let data = JSON.parse(source);
					SCHEDULE.Times = data.schedule_info;
					callback();
				} else {
					$.getJSON(source, function(data) {
						// console.log('here', data);
						// Format dates if Ticketmaster calendar
						SCHEDULE.Times = data.schedule_info;
						// console.log('schedule times set');
						callback();
					});
				}
			},

			// Populates Schedule Menu
			PopulateWeekly: function(container, eventslist) {

				// console.log('here', eventslist);

				//Append ticket links to corresponding date div
				for (var i = 0; i < eventslist.length; i++) {
					//var eventDate = "." + eventslist[i].start.slice(-5);
					let eventDate = "." + eventslist[i].start;
					let eventTime = eventslist[i].title;
					let isBest = eventslist[i].best ? 'event-time--best' : '';
					let eventInfo;

					// console.log(eventslist[i]);
					// var eventInfo = "<a class='matweekly " + isBest + " '" + eventTime + " target='_blank' href='" + eventslist[i].url + "'>" + eventTime + "</a>";
					if( eventslist[i].featured ) {
						eventInfo = "<div class='featured-artist' href='" + eventslist[i].url + "'><span>" + eventslist[i].featured + " *</span></div>";
					} else {
						eventInfo = "<a class='matweekly event-time " + isBest + " ' target='_blank' href='" + eventslist[i].url + "'>" + eventTime + "</a>";
					}
					// Best availability (weekly on homepage)
					$('#weekly-calendar').find(eventDate).find(".tc").append(eventInfo);
				}

			},

			// WEEKLY LINK FORMATTING
			// Call this for Ticketmaster calendars with direct performance ticket links
			Weekly: function(container) {
				// console.log('what', SCHEDULE.Times);

				var eventslist = [];

				//Date fix
				var calDate = new Date();
				calDate.setDate(calDate.getDate() - 1);

				//var wDays = 0;

				// Format events for calendar
				for (var i = 0; i < Object.keys(SCHEDULE.Times).length; i++) {

					var showYear = SCHEDULE.Times[i].year;
					var showMonth = SCHEDULE.Times[i].dateID;
					if (showMonth.length < 2 && showMonth < 10) { // +0 to front of time if needed
						var zeroString = '0';
						showMonth = zeroString.concat(showMonth);
					}
					var linkMonth = showMonth;
					var hoursKey = Object.keys(SCHEDULE.Times[i].hours);

					for (var j = 0; j < hoursKey.length; j++) {
						var showDay = hoursKey[j];
						var timesKey = Object.keys(SCHEDULE.Times[i].hours[showDay]);
						for (var k = 0; k < timesKey.length; k++) {
							var eveMat = timesKey[k];
							var theTime = SCHEDULE.Times[i].hours[showDay][eveMat];
							var linkTime = theTime;
							var featured = theTime.artist ?? '';

							if (linkTime && linkTime.length < 7) { // +0 to front of time if needed
								var zeroString = '0';
								linkTime = zeroString.concat(linkTime);
							}
							if (eveMat != 'dark') {

								var linkDay = (Number(showDay)+1).toString();
								if (linkDay.length < 2 && linkDay < 10) { // +0 to front of time if needed
									var zs = '0';
									linkDay = zs.concat(linkDay);
								};
								let showDate = linkMonth + "/" + linkDay + "/" + showYear;
								var startDate = showYear + "-" + showMonth + "-" + linkDay;

								//  If Time OR Featured Exists
								// AND date is before today
								if (theTime.time || featured && calDate <= new Date(startDate)) {
									eventslist.push({
										start: startDate, // previously: SCHEDULE.Times[i].date,
										url: 'http://www.telecharge.com/Broadway/freestyle-love-supreme/Ticket?PerformanceDateTime=' + showDate + '%20' + linkTime.time + 'PM',
										title: theTime.time + '<span class="ampm">PM</span>',
										best: theTime.best,
										featured: featured
									});
								}
							}
						};

					};
					/*
					wDays++;
					if (wDays == 7) { break; }
					*/
				}
				SCHEDULE.PopulateWeekly(container, eventslist);
			},

			//calendar creation function
			initWeekly: function() {

				var months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

				var calText = "";
				document.getElementById("weekly-calendar").innerHTML = calText;

				var thisDay = new Date();
				var weekday = new Array(7);
				weekday[0] = "SUN";
				weekday[1] = "MON";
				weekday[2] = "TUE";
				weekday[3] = "WED";
				weekday[4] = "THU";
				weekday[5] = "FRI";
				weekday[6] = "SAT";

				// get today's date
				var d = thisDay.getDate();
				var m = thisDay.getMonth();
				var y = thisDay.getFullYear();
				var n = weekday[thisDay.getDay()];

				// generate weekday names
				calText += '<div class="week-row week-names">';
				for (let i = thisDay.getDay(); i < thisDay.getDay() + 7; i++) {
					let the_day = i;
					if (the_day > 6) {
						the_day = the_day - 7;
					}
					calText += '<div>' + weekday[the_day] + '</div>';
				}
				calText += '</div>';

				//calText = '<div class="month row-fluid"><h3 class="col-sm-5 text-center">' + months[m] + " " + y + '</h3><h5 class="col-sm-7 text-center">CLICK ON A DATE TO BUY ONLINE.</h5><div><div class="date">Sun</div><div class="date">Mon</div><div class="date">Tue</div><div class="date">Wed</div><div class="date">Thu</div><div class="date">Fri</div><div class="date">Sat</div>';

				calText += '<div class="week-row">'; // open a week row
				for (let j = 0; j < 14; j++) {

					var d = thisDay.getDate();
					var m = thisDay.getMonth();
					var y = thisDay.getFullYear();
					var n = weekday[thisDay.getDay()];

					if (m < 9) {
						if (d <= 9) {
							var thisDate = y + "-0" + (m + 1) + "-0" + d;
						} else {
							var thisDate = y + "-0" + (m + 1) + "-" + d;
						}
					} else {
						if (d <= 9) {
							var thisDate = y + "-" + (m + 1) + "-0" + d;
						} else {
							var thisDate = y + "-" + (m + 1) + "-" + d;
						}
					}

					calText += '<div class="date-box ' + thisDate + '"><div class="date-box-content"><p class="day-weekly">' + n + '</p><div class="weekday-box"><p class="date">' + (m + 1) + '/' + d + '</p><div class="weekly-perf-holder"><div class="t"><div class="tc">';
					//calText += "<div class=\"day active "+thisDate+" ind"+ind+"\" data-date=\""+thisDate+"\" data-ind=\""+ind+"\"><span class=\"num\">" + j + "</span></div>";
					calText += '</div></div></div></div></div></div>';
					//ind++;

					thisDay.setDate(thisDay.getDate() + 1);


					// wrap after 7 days; change to a new week row
					if (j == 6) {
						calText += '</div><!-- end interim week row --><div class="week-row">';
					}

				}
				calText += '</div><!-- end week row -->'; // close a week row

				document.getElementById("weekly-calendar").innerHTML += calText;

				calText = "";


				//}

			}

		};

		COMMONUTILS.userLocation(COMMONUTILS.currentPage);
	}

	function monthly() {
		
		var COMMONUTILS = {
			//
			pageWidth: function() {
				"use strict";
				return document.documentElement.clientWidth;
			},
		
			// OBJ TO HOLD USERS CURRENT WEBPAGE LOCATION
			// currentPage: window.location.pathname.substring(window.location.pathname.lastIndexOf('/') + 1),
			currentPage: window.location.pathname.replace(/\//g, ""),
		
			// FUNCTION TO EXECUTE CODE BASED ON LOCATION
			userLocation: function(pagename) {
				"use strict";
				let parsedEvents = JSON.parse(calendar.dataset.events);
				// console.log('JSON Parsed Events: ', parsedEvents);
				SCHEDULE.getData(SCHEDULE.sched, "#cal", "freestyle-love-supreme");
			},
		};
		
		// NAMESPACE FOR SCHEDULE FUNCTIONS
		var SCHEDULE = {
			// JSON results for show dates and times will be stored here
			Times: null,
			Avail: null,
			sched: JSON.parse(calendar.dataset.events),
			Schedule: null,
		
			getData: function(schedule, targetdiv, href) {
				SCHEDULE.Schedule = schedule;
				var results = SCHEDULE.schedulePop(SCHEDULE.Schedule, href); //********
				$(targetdiv).append(results);

				function resetArrowsIfNoMonths() {
					var months = $(".month").length;
					var next = $(".month:visible").index();

					// console.log("right months: ", months);
					// console.log("right next: ", next);
					if (months == next) {
						$(".cal-left, .cal-right").addClass("inactive");
					}
				}
				resetArrowsIfNoMonths();

				$(".cal-left").click(function(e) {
					e.preventDefault();
					var months = $(".month").length;
					var prev = $(".month:visible").index() - 1;

					if ($(".cal-right").hasClass("inactive")) {
						$(".cal-right").removeClass("inactive");
					}

					// console.log("left months: ", months);
					// console.log("left prev: ", prev);

					if (prev > 0) {
						// console.log('continue');
						$(".month:visible").hide();
						$(".month").eq(prev).fadeIn("slow");
					} else if (prev == 0) {
						// console.log('stop');
						$(".cal-left").addClass("inactive");
						$(".month:visible").hide();
						$(".month").eq(prev).fadeIn("slow");
					}
				});

				$(".cal-right").click(function(e) {
					e.preventDefault();
					var months = $(".month").length - 1;
					var next = $(".month:visible").index() + 1;

					// console.log("right months: ", months);
					// console.log("right next: ", next);

					if ($(".cal-left").hasClass("inactive")) {
						$(".cal-left").removeClass("inactive");
					}

					if (next < months) {
						// console.log('continue');
						$(".month:visible").hide();
						$(".month").eq(next).fadeIn("slow");
					} else {
						// console.log('stop');
						$(".month:visible").hide();
						$(".month").eq(next).fadeIn("slow");
						$(".cal-right").addClass("inactive");
					}
				});
			},
		
			// Get JSON file, call appropriate parsing function after
			Fetch: function(source, callback) {
				$.getJSON(source, function(data) {
					// Format dates if Ticketmaster calendar
					SCHEDULE.Times = data;
					callback();
				});
			},
		
			// Populates Schedule Menu
			schedulePop: function(schedule, href) {
				// console.log(schedule);
				var today = new Date();
				var schedule_info = schedule.schedule_info;
		
				// remove previous months, respecting month AND year
				var today = new Date();
				var dmo = today.getMonth();
				dmo++; // because months are 0 indexed
				var dy = today.getFullYear();
				var monthYear = new Date(dy, dmo);
		
				for (let di = 0; di < schedule_info.length; di++) {
					var currentMonthYear = new Date(
						schedule_info[0].year,
						schedule_info[0].dateID
					);
					if (currentMonthYear.getTime() < monthYear.getTime()) {
						// console.log("shifted");
						schedule_info.shift();
					}
				}
		
				var months = schedule_info.length;
				var days = [
					"Sunday",
					"Monday",
					"Tuesday",
					"Wednesday",
					"Thursday",
					"Friday",
					"Saturday",
				];
				var schedule_html = "";
		
				// Add 0 to single digit months
				var todayMonth = today.getMonth().toString().length == 1 ? "0" + (today.getMonth() + 1).toString() : (today.getMonth() + 1).toString();
		
				for (var i = 0; i < months; i++) {
					var offset = ""; // setup blank days before first day of month
					for (var f = 0; f < schedule_info[i].offset; f++) {
						offset += '<div class="day-box off_set">&nbsp;</div>';
					}
					var after = ""; // setup blank days after last day of month
					for (var t = 0; t < schedule_info[i].after; t++) {
						after += '<div class="day-box off_set">&nbsp;</div>';
					}
					var calendar = "";
		
					// IF IT'S THIS MONTH ( DISPLAYS PAST DATES DARK )
					if ( schedule_info[i].dateID == (today.getMonth() + 1).toString() && schedule_info[i].year == today.getFullYear().toString() ) {
						for (let dayNumber = 1; dayNumber <= Number(schedule_info[i].days); dayNumber++) {
							// dayNumber = iterates every day in the month
							// console.log(dayNumber, schedule_info[i] );
							if (today.getDate() > dayNumber) {
								// console.log(dayNumber, 'shoulw show blank');
								// days before today
								calendar += '<div class="day-box dark"><p class="date-2">' + dayNumber + "</p></div>";
							} else {
								// console.log(dayNumber, 'shows today and later on', schedule_info[i].hours[dayNumber-1]);
								if ( schedule_info[i].hours[dayNumber-1] && Object.keys(schedule_info[i].hours[dayNumber-1])[0] != "dark") {
									// console.log(dayNumber, 'shows w/ performance');
									// Render Date/Times Here
									var datedeets = schedule_info[i].hours[dayNumber-1];
		
									// set a class to date
									calendar += '<div class="day-box ' + schedule_info[i].dateID + "-" + dayNumber + '"><p class="date-2">' + dayNumber + '</p><div class="perf-links-holder">';	
									for (var key in datedeets) {
										
										var date = new Date( schedule_info[i].dateID + "/" + dayNumber + "/" + schedule_info[i].year );
										var dayofweek = days[date.getDay()];
										var showtime = datedeets[key];
										var linkDate = schedule_info[i].dateID;
										let isBest = datedeets[key].best ? 'event-time--best' : '';

										if (showtime.length < 5) {
											// +0 to front of showtime if needed
											var zeroString = "0";
											showtime = zeroString.concat(showtime);
										}
										if (linkDate.startsWith("0")) {
											// -0 to front of date if needed
											linkDate = linkDate.substr(1);
										}

										if(datedeets['featured'] && datedeets['featured'].artist && typeof datedeets[key].artist === 'string' ) {
											calendar += '<div class="featured-artist"><span>' + datedeets[key].artist + ' *</span></div>';
										} else if (datedeets[key].time) {
											calendar += '<a class="cal-link event-time ' + isBest + ' ' + key + '" href="http://www.telecharge.com/Broadway/' + href + "/Ticket?PerformanceDateTime=" + linkDate + "/" + dayNumber + "/" + schedule_info[i].year + "%20" + showtime.time + 'PM" class="time" target="_blank">' + datedeets[key].time + '<span class="ampm no-pm-mobile">pm</span>' + "</a>";
										}
									}
									calendar += "</div></div>";
								} else {
									// console.log(dayNumber, 'dark');
									// If Day has no performance, show empty
									calendar += '<div class="day-box dark"><p class="date-2">' + dayNumber + "</p></div>";
								}
							}
						}
					} else {
						// IF IT'S NOT THIS MONTH ( DISPLAYS FULL MONTH )
						for (var m = 1; m <= Number(schedule_info[i].days); m++) {
							if (schedule_info[i].hours[m-1] && Object.keys(schedule_info[i].hours[m-1])[0] != "dark") {
								var datedeets = schedule_info[i].hours[m-1];
								var date = new Date( schedule_info[i].full_month + " " + m + ", " + schedule_info[i].year );
								var dayofweek = days[date.getDay()];
								
								calendar += '<div class="day-box ' + schedule_info[i].dateID + "-" + m + '"><p class="date-2">' + m + '</p><div class="perf-links-holder">';
								
								for (var key in datedeets) {
									var showtime = datedeets[key];
									let isBest = datedeets[key].best ? 'event-time--best' : '';
		
									if (showtime.length < 5) {
										// +0 to front of showtime if needed
										var zeroString = "0";
										showtime = zeroString.concat(showtime);
									}
									var linkDate = schedule_info[i].dateID;
									if (linkDate.startsWith("0")) {
										// -0 to front of date if needed
										linkDate = linkDate.substr(1);
									}
		
									// console.log('test',datedeets);
									// Took out '&' in link to get it to work
									// NOTE: NORMAL LINK FOR FUTURE USE
									if(datedeets['featured'] && datedeets['featured'].artist && typeof datedeets[key].artist === 'string' ) {
										calendar += '<div class="featured-artist"><span>' + datedeets[key].artist + ' *</span></div>';
									} else if (datedeets[key].time) {
										calendar += '<a class="cal-link event-time ' + isBest + ' ' + key + '" href="http://www.telecharge.com/Broadway/' + href + "/Ticket?PerformanceDateTime=" + linkDate + "/" + m + "/" + schedule_info[i].year + "%20" + showtime.time + 'PM" class="time" target="_blank">' + datedeets[key].time + '<span class="ampm no-pm-mobile">pm</span>' + "</a>";
									}
								}
								calendar += "</div></div>";
							} else {
								// console.log('in', m);
								calendar +=
									'<div class="day-box dark"><p class="date-2">' + m + "</p></div>";
							}
						}
					}
					// var bestSubhead = "";
					// if (headerData.ticketSubhead) {
					// 	bestSubhead = headerData.ticketSubhead;
					// }
		
					schedule_html =
						schedule_html +
						`
			  <div class="month">
			  <div class="month-hed">
			  <div class="cal-nav">
				<a class="cal-left inactive" href="#">
				  <img class="cal-arrow-icon" src="${headerData.themeDir}/_images/cal-prev-red.svg">
				</a>
				<h3 class="mobilemonth">` +
						schedule_info[i].full_month +
						" " +
						schedule_info[i].year +
						`</h3>
				<a class="cal-right" href="#">
				  <img class="cal-arrow-icon" src="${headerData.themeDir}/_images/cal-next-red.svg">
				</a>
			  </div>
			  <div class="best-box">
				<div class="best-color extension"></div>
				<p class="best-text">= BEST AVAILABILITY</p>
			  </div>
		
			  <div class="days"><div class="day">Sun</div><div class="day">Mon</div><div class="day">Tue</div><div class="day">Wed</div><div class="day">Thu</div><div class="day">Fri</div><div class="day">Sat</div></div></div><div class="grid">` +
						offset +
						calendar +
						after +
						"</div></div></div>";
				}
		
				return schedule_html;
			},
		};

		COMMONUTILS.userLocation(COMMONUTILS.currentPage);	
	}



	return {
		init: init
	};
})();
